import React, { useState, useEffect, useContext, useMemo, Suspense } from 'react';
import Loader from '../../components/utilities/Loader';
import { USBGrid, USBColumn, USBButton, USBCheckbox, } from '@usb-shield/components-react';
import TopMenu from '../../components/molecules/TopMenu';
import BannerWarning from '../../components/common/banner';
import GlobalHead from '../../components/organisms/GlobalHead';
import GlobalFooter from '../../components/organisms/GlobalFooter';
import { USBIconPeople, USBIconProfile, USBIconPerson, USBIconDocument, USBIconMail, USBIconBriefcase, USBIconFolderClosed, USBIconSettings, USBIconEnvelope, USBIconInfo } from '@usb-shield/components-react/dist/cjs';
import useUserRole from '../../components/Hooks/use-UserRole'
import { PermissionRoleContext } from '../../components/Hooks/usePermissionRoles';
import { FeatureFlagsContext } from '../../components/Hooks/useFeatureFlags';
import { FeatureCategoryContext } from '../../components/Hooks/useFeatureCategories';
import { DocContext } from '../../pages/context/DocContext'
import { DashboardContext } from '../../pages/context/DashboardContext'
import { endpoints } from '../../../config/connections';
import callApi from '../../components/utilities/callApi';
import axios from 'axios';
import rateLimit from 'axios-rate-limit';
import SessionHeader from './SessionHeader';
import useSessionMaintainer from '../../components/Hooks/useSessionMaintainer';
import moment from 'moment';
import actionlogo from '../../assets/images/rightArrow.png';
import logo from '../../assets/images/usbank.png';
import portalIndicator from '../../../assets/img/portal.png';
import dateAlertIcon from '../../../assets/img/dateAlert.png';



import './landingPage.css'
import { getAxiosInstance } from '../Requirements/utils';

const LandingPage = () => {

    const userCheck = useUserRole();
    const { currentToken, getCurrentExtendTime, onSuccessChallenge, extendSessionSuccess, onIdleTimeoutLogoutSuccess, onIdleTimeoutLogoutFailure } = useSessionMaintainer()
    const authenticationPlugins = [
        '../../plugins/transmit/xmsdk.js',
        '../../plugins/transmit/xmui.js',
    ];
    const { permissionDetails } = useContext(PermissionRoleContext);
    const { featureDetails } = useContext(FeatureFlagsContext);
    const { categories } = useContext(FeatureCategoryContext);
    const { userType, servicingUserRole, currentMenu, userName, assignedUserName } = useContext(DocContext);
    const remote_customer = JSON.parse(sessionStorage.getItem('remote_user'))
        ? JSON.parse(sessionStorage.getItem('remote_user')).userID
        : null;
    const [remoteUserPermissions, setRemoteUserPermissions] = useState([])
    const [remoteUserFeatureFlags, setRemoteUserFeatureFlags] = useState([])
    const allowedHosts = ['localhost', 'it1-docmanagement.us.bank-dns.com'];
    const isAllowedHost = allowedHosts.includes(window.location.hostname);
    const [topDocuments, setTopDocuments] = useState([]);
    const [sortColumn, setSortColumn] = useState('dueDate');
    const [sortDirection, setSortDirection] = useState('asc');
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);

    const closingBinderCategoryLookup = useMemo(() => {
        const closingBinderCategory = categories.find((category) => category.key === 'closingBinderCategory');
        const closingBinderItems = closingBinderCategory?.items || [];
        return new Set(closingBinderItems.map((item) => item.toLowerCase()));
    }, [categories]);

    const tiles = [
        { title: 'My Portfolio', icon: <USBIconBriefcase size={64} colorVariant={'brand-primary'} title={'My Portfolio'}></USBIconBriefcase>, url: '/ReportingDashboard', visibility: sessionStorage.getItem('remote_user') ? ["portfolio"].some(cb => remoteUserPermissions?.includes(cb)) : ["portfolio"].some(cb => permissionDetails?.includes(cb)) },
        { title: 'Closing Binders', icon: <USBIconFolderClosed size={64} colorVariant={'brand-primary'} title={'Closing Binders'}></USBIconFolderClosed>, url: '/ClosingBinders/Portfolio', visibility: (userCheck === 'employee' && !sessionStorage.getItem('remote_user')) && ["cbportfolio", "cbdoctype", "cbfilenettype"].some(cb => permissionDetails?.includes(cb)) },
        { title: 'Inbox', icon: <USBIconEnvelope size={64} colorVariant={'brand-primary'} title={'Inbox'}></USBIconEnvelope>, url: '/Inbox', visibility: sessionStorage.getItem('remote_user') ? ["inbox"].some(cb => remoteUserPermissions?.includes(cb)) && ["feature_inbox_visible"].some(cb => remoteUserFeatureFlags?.includes(cb)) : ["inbox"].some(cb => permissionDetails?.includes(cb)) && ["feature_inbox_visible"].some(cb => featureDetails?.includes(cb)) },
        { title: 'Manage Users', icon: <USBIconPeople size={64} colorVariant={sessionStorage.getItem('remote_user') ? 'grey80' : 'brand-primary'} title={'Manage Users'}></USBIconPeople>, url: '/ManageUser', visibility: sessionStorage.getItem('remote_user') ? (JSON.parse(sessionStorage.getItem('remote_user')).profileRole == "Site Administrator" || remoteUserPermissions?.includes("manageusers")) : (userCheck === 'employee' || userCheck === 'portaladmin' || servicingUserRole === 'siteadmin' || servicingUserRole === 'vendorsiteadmin') && permissionDetails?.includes("manageusers") },
        { title: 'Document Templates', icon: <USBIconDocument size={64} colorVariant={'brand-primary'} title={'Document Template'}></USBIconDocument>, url: '/DocumentTemplate', visibility: sessionStorage.getItem('remote_user') ? ["inbox"].some(cb => remoteUserPermissions?.includes(cb)) && !["portfolio"].some(cb => remoteUserPermissions?.includes(cb)) ? false : true : ["inbox"].some(cb => permissionDetails?.includes(cb)) && !["portfolio"].some(cb => permissionDetails?.includes(cb)) ? false : true },
        { title: 'Reports', icon: <USBIconMail size={64} colorVariant={'brand-primary'} title={'Reports'}></USBIconMail>, url: '/Reports/CustomerAccessFilter', visibility: userCheck === 'employee' && !sessionStorage.getItem('remote_user') && permissionDetails?.includes("reports") },
        { title: 'Tools', icon: <USBIconSettings size={64} colorVariant={'brand-primary'} title={'Tools'}></USBIconSettings>, url: '/FeatureFlags', visibility: userCheck === 'employee' && !sessionStorage.getItem('remote_user') && ["tools"].some(item => permissionDetails?.includes(item)) },
        { title: 'Contacts', icon: <USBIconProfile size={64} colorVariant={'brand-primary'} title={'Contacts'}></USBIconProfile>, url: '/Contacts', visibility: (userCheck !== 'employee' || sessionStorage.getItem('remote_user')) && ["feature_contacts_visible"].some(cb => featureDetails?.includes(cb)) },
        { title: 'DevSecOps', icon: <USBIconInfo size={64} colorVariant={'brand-primary'} title={'DevSecOps'}></USBIconInfo>, url: '/Scans', visibility: userCheck === 'employee' && !sessionStorage.getItem('remote_user') && ["tools"].some(item => permissionDetails?.includes(item)) && isAllowedHost },
    ]

    const getRemoteUserPermissions = () => {
        callApi.getApiDataLoggedUser(`${endpoints.apigee}/document-management/coreservice/user-management/v1/allowedPages?role=${JSON.parse(sessionStorage.getItem('remote_user')).profileRole}`, '', {
            headers: {
                'Client-Application': 'CDC',
                'jwt': `${sessionStorage.getItem('tok')}`,
                'user-id': JSON.parse(sessionStorage.getItem('remote_user')).userID
            }
        }).then((permissions) => {
            if (permissions?.response?.status == 401) {
                if (confirm("Session Expired. Please login again") == true) {
                    onLogout()
                }
            } else {
                setRemoteUserPermissions(permissions.data)
            }
        })
    }

    const getRemoteUserFeatures = () => {
        callApi.getApiDataLoggedUser(`${endpoints.apigee}/document-management/coreservice/user-management/v1/get-all-features`, '', {
            headers: {
                'Client-Application': 'CDC',
                'jwt': `${sessionStorage.getItem('tok')}`,
                'user-id': JSON.parse(sessionStorage.getItem('remote_user')).userID
            }
        }).then((response) => {
            if (response?.response?.status == 401) {
                if (confirm("Session Expired. Please login again") == true) {
                    onLogout()
                }
            } else {
                let flags = [];
                response?.data?.forEach((flag) => {
                    if (flag.feature === 'feature_banner_visible') {
                        setRemoteUserFeatureFlags(flag)
                    }
                    if (
                        (flag.users.includes(sessionStorage.getItem('loggedUser')) ||
                            flag.users.includes('*')) &&
                        flag?.enable
                    ) {
                        flags.push(flag.feature);
                    }
                });

                setRemoteUserFeatureFlags(flags);
            }
        })
    }

    const removeImpersonatedForCB = (e) => {
        if (sessionStorage.getItem('remote_user')) {
            if (confirm("Are you sure you want to navigate to Closing Binders page? This will reset view to your profile if you were impersonating any user/viewing another user's profile.") == true) {
                sessionStorage.setItem('assignedUser', sessionStorage.getItem('loggedUser'));
                sessionStorage.removeItem('remote_user');
                window.location.href = '/ClosingBinders/Portfolio'
            }
        } else {
            window.location.href = '/ClosingBinders/Portfolio'
        }
    }

    const onLogout = () => {
        sessionStorage.removeItem("remote_user")
        sessionStorage.removeItem("portfolioFilters")
        if (userCheck !== 'employee') {
            const userDataTmp = JSON.parse(sessionStorage.getItem('userData'));
            sessionStorage.clear();
            sessionStorage.setItem("userData", JSON.stringify(userDataTmp));
            window.location.href = '/';
        } else {
            const userDataTmp = JSON.parse(sessionStorage.getItem('userData'));
            sessionStorage.clear();
            sessionStorage.setItem("userData", JSON.stringify(userDataTmp));
            window.location.href = '/EmployeeRedirect?tp=lg';
        }
    };

    const getAllDocuments = async (userId, remote) => {
        let urlPathVal1 = '';
        let urlPathVal2 = '';
        let urlPathVal3 = '';
        if (sessionStorage.getItem('userrole') === 'employee' && !remote) {
            urlPathVal1 = 'requirements';
            urlPathVal2 = 'employee';
            urlPathVal3 = 'documents';
        } else {
            if (sessionStorage.getItem('view_as')) {
                urlPathVal1 = 'requirements';
                urlPathVal2 = 'employee';
                urlPathVal3 = 'documents';
            } else {
                urlPathVal1 = 'landing-page';
                urlPathVal2 = 'users';
                urlPathVal3 = 'requirement-details';
            }
        }
        const callTypeBefore = 'before';
        const callTypeFuture = 'future';


        const apiURLFirst = `${endpoints.apigee}/document-management/cdc/${urlPathVal1}/v1/${urlPathVal2}/userId/${urlPathVal3}?callType=${callTypeBefore}&startDay=-9999&endDay=9999&status=${'Not Submitted'}&recordsCount=`;

        let allData = [];
        const https = rateLimit(
            axios.create({
                headers: {
                    Accept: 'application/json',
                    'Correlation-ID': `${sessionStorage.getItem(
                        'loggedUser'
                    )} ${sessionStorage.getItem('correlationId')}`,
                    'Client-Application': 'CDC',
                    Authorization: `Bearer ${sessionStorage.getItem('at')}`,
                    'jwt': `${sessionStorage.getItem('tok')}`,
                    'user-id': `${userId}`
                },
            }),
            { maxRequests: 7, perMilliseconds: 1000, maxRPS: 7 }
        );

        let docIds = [];
        let userID = sessionStorage.getItem('loggedUser');
        let userrole = sessionStorage.getItem('userrole');

        https.get(apiURLFirst + 0).then(async (response) => {
            let docs = userrole === 'employee' && !sessionStorage.getItem('remote_user') ? response?.data?.docs : response?.data;
            const today = moment(new Date(), 'YYYYMMDD');
            const threeMonthsAgo = moment(new Date(), 'YYYYMMDD').subtract(3, 'months').startOf('day');
            const threeMonthsFromNow = moment(new Date(), 'YYYYMMDD').add(3, 'months').startOf('day');
            if (docs.length > 0) {
                allData = docs;
            }
            const url = `${endpoints.apigee}/document-management/cdc/requirements/v1/inbox/requirements`;
            const https = getAxiosInstance();
            const inboxResponse = await https.get(url);
            if (inboxResponse?.status === 200) {
                allData = [...allData, ...inboxResponse?.data];
            }
            allData = allData.filter(doc => {
                if (doc.status === "New") {
                    // return doc.status === "New"
                    if (doc?.dueDate) {
                        const docdueDate = moment(doc.dueDate, 'YYYYMMDD');
                        return docdueDate.isBetween(threeMonthsAgo, threeMonthsFromNow) || docdueDate.isSame(today, 'day');
                    } else {
                        return doc.status === "New"
                    }
                } else {
                    const docdueDate = moment(doc.dueDate, 'YYYYMMDD');
                    return docdueDate.isBetween(threeMonthsAgo, threeMonthsFromNow) || docdueDate.isSame(today, 'day');
                }
            });
            setTopDocuments(allData);
            console.log("allData", topDocuments);
        }).catch((error) => {
            console.log('Error while fetching documents for landing page', error);
            return [];
        }).finally(() => {
            setLoading(false);
        });
    }

    const getTopDocuments = async () => {
        setLoading(true);
        const remote_customer = JSON.parse(sessionStorage.getItem('remote_user'))
            ? JSON.parse(sessionStorage.getItem('remote_user')).userID
            : null;
        const view_as = sessionStorage.getItem('view_as')
            ? `${JSON.parse(sessionStorage.getItem('view_as')).bankerId}@cdcemp`
            : null;
        if (remote_customer) {
            await getAllDocuments(remote_customer, true);
        } else if (view_as) {
            await getAllDocuments(view_as);
        } else {
            await getAllDocuments(sessionStorage.getItem('assignedUser'));
        }
    }

    const handleSort = (columnName) => {
        if (sortColumn === columnName) {
            setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
        } else {
            setSortColumn(columnName);
            setSortDirection('asc');
        }
    };

    const getSortedDocuments = () => {
        if (!topDocuments || topDocuments.length === 0) return [];

        const sorted = [...topDocuments].sort((a, b) => {
            let aValue, bValue;

            switch (sortColumn) {
                case 'dueDate':
                    aValue = new Date(a.dueDate);
                    bValue = new Date(b.dueDate);
                    break;
                case 'dealName':
                    aValue = a.metadata?.dealName || a.metadata?.syndicationFundName || 'Not applicable';
                    bValue = b.metadata?.dealName || b.metadata?.syndicationFundName || 'Not applicable';
                    aValue = aValue.toLowerCase();
                    bValue = bValue.toLowerCase();
                    break;
                case 'reportingEntity':
                    aValue = (a.metadata?.reportingEntity || '').toLowerCase();
                    bValue = (b.metadata?.reportingEntity || '').toLowerCase();
                    break;
                case 'category':
                    aValue = (a.category || '').toLowerCase();
                    bValue = (b.category || '').toLowerCase();
                    break;
                case 'asOfDate':
                    aValue = a.asOfDate || '';
                    bValue = b.asOfDate || '';
                    break;
                case 'submittedDate':
                    aValue = a.submittedDate ? new Date(a.submittedDate) : new Date(0);
                    bValue = b.submittedDate ? new Date(b.submittedDate) : new Date(0);
                    break;
                case 'status':
                    aValue = (a.status || '').toLowerCase();
                    bValue = (b.status || '').toLowerCase();
                    break;
                default:
                    return 0;
            }

            if (aValue < bValue) return sortDirection === 'asc' ? -1 : 1;
            if (aValue > bValue) return sortDirection === 'asc' ? 1 : -1;
            return 0;
        });

        return sorted;
    };

    const getPaginatedDocuments = () => {
        const sorted = getSortedDocuments();
        const startIndex = (currentPage - 1) * pageSize;
        const endIndex = startIndex + pageSize;
        return sorted.slice(startIndex, endIndex);
    };

    const getTotalPages = () => {
        const sorted = getSortedDocuments();
        return Math.ceil(sorted.length / pageSize);
    };

    const handlePageSizeChange = (newPageSize) => {
        setPageSize(newPageSize);
        setCurrentPage(1);
    };

    const tblContentTemplate = (item, filterStatus, setActionsDrop, tempUserRole, setLoading, setCurrentPage, currentPage, includesCBDocs, statusData) => {
        const docDate = item.dueDate;
        const docdueDate = moment(item.dueDate, 'YYYYMMDD').format('YYYYMMDD');
        let dateHtml;
        let dueHtml = <></>;

        const disabledID = sessionStorage.getItem('userrole') === 'employee' && !sessionStorage.getItem('remote_user') && sessionStorage.getItem('userData') && JSON.parse(sessionStorage.getItem('userData')).emailId ? false : true;

        const today = moment(new Date(), 'YYYYMMDD').format('YYYYMMDD');
        if (docDate != null && item.requirementName?.toLowerCase() !== "construction draw") {
            const days = moment(docdueDate, 'YYYYMMDD').diff(
                moment(today, 'YYYYMMDD'),
                'days'
            );
            if (days === 0 && item.status === 'Not Submitted') {
                dueHtml = <div className="date-details">Due today</div>;
            } else if (days > 0 && item.status !== 'Completed') {
                dueHtml = (
                    <div className="date-details">
                        Due in&nbsp;
                        {days}
                        &nbsp;
                        {days > 1 ? 'days' : 'day'}
                    </div>
                );
            } else if (days < 0 && item.status !== 'Completed') {
                dueHtml = <div className="font-red date-details">
                    <span className="date-alert">
                        <img src={dateAlertIcon} />
                    </span>
                    <span>Past due</span>
                </div>
            }
            dateHtml = (
                <div>
                    {moment(docdueDate).format('MM/DD/YYYY')}
                    <div>{dueHtml}</div>
                </div>
            );
        } else dateHtml = '-';

        let dealNametext = '';
        let dealNumberText;
        if (
            (item.metadata.syndicationFundName === '' ||
                item.metadata.syndicationFundName === null || item.metadata.syndicationFundName === undefined) &&
            (item.metadata.dealName === '' || item.metadata.dealName === null || item.metadata.dealName === undefined)
        ) {
            dealNametext = 'Not applicable';
            dealNumberText = '';
        } else if (
            item.metadata.syndicationFundName === '' ||
            item.metadata.syndicationFundName === null ||
            item.metadata.syndicationFundName === undefined
        ) {
            dealNametext = item.metadata.dealName;
            dealNumberText = item.metadata.dealId;
        } else if (
            (item.metadata.dealName === '' || item.metadata.dealName === null || item.metadata.dealName === undefined) &&
            item.metadata.showSyndicationFundInd === true
        ) {
            dealNametext = item.metadata.syndicationFundName;
            dealNumberText = item.metadata.syndicationFund;
        } else if (
            (item.metadata.dealName === '' || item.metadata.dealName === null || item.metadata.dealName === undefined) &&
            item.metadata.showSyndicationFundInd === false
        ) {
            dealNametext = 'Not applicable';
            dealNumberText = '';
        } else if (
            sessionStorage.getItem('userrole') !== 'employee' &&
            item.metadata.showSyndicationFundInd === false
        ) {
            dealNametext = item.metadata.dealName;
            dealNumberText = item.metadata.dealId;
        } else {
            dealNametext = `${item.metadata.dealName} | ${item.metadata.syndicationFundName}`;
            dealNumberText = item.metadata.dealId;
        }

        const legalEntityHtml = item.metadata.reportingEntity;
        const parentCompanyHtml = item.metadata.parentCompanyName;

        let docCategory = '';
        if (item.category === null) {
            docCategory = <div className="empty-div" />;
        } else docCategory = item.category;
        const isClosingBinderCategory = closingBinderCategoryLookup.has((docCategory + '')?.toLowerCase());
        const docRequirement = item.requirementName;

        const asofDate = item.asOfDate ? item.asOfDate : "-";
        const cbDate = includesCBDocs && item.category == "Closing Binder" ? item.closingBinderDate ? moment.utc(item.closingBinderDate).format('MM/DD/YYYY') : "N/A" : "N/A"

        let asofdateHtml;
        if (includesCBDocs && cbDate !== "N/A") {
            asofdateHtml = <div>
                <div>{asofDate}<hr />{cbDate}</div>
            </div>
        } else {
            asofdateHtml = <div>{asofDate}</div>;
        }
        let submittedDateHtml = item.submittedDate ? moment(item.submittedDate).format('MM/DD/YYYY') : '-';
        let statusHtml = <div className="data-table-cell">{item.status}</div>;
        const docId = item.id;
        // Row click destination (whole row is clickable; no visible Action column)
        const rowHref = item.status === "New" ? `/Inbox/${item.id}?status=${item.status}` : docCategory == "Closing Binder" ? `/ClosingBinders/Portfolio/Requirements?id=${docId}` : `/RequirementDetails?id=${docId}`;
        let tableDataObject = {
            rowHref,
            first: dateHtml,
            second: (
                <div>
                    <div className="span-bold">{dealNametext}</div>
                    <div className="data-table-subcell">{dealNumberText}</div>
                </div>
            ),
            third: (
                <div>
                    <div className="span-bold">{parentCompanyHtml}</div>
                    <div className="data-table-subcell">{legalEntityHtml}</div>
                </div>
            ),
            fourth: (
                <div className="data-table-cell">
                    <div className="span-bold">{docCategory}</div>
                    <div className="data-table-subcell">{docRequirement}</div>
                    {item.status !== "New" && item.portalSubmitted ? (
                        <div className="expand-column-portal">
                            <div className="portal-indicator">
                                <img src={portalIndicator} alt="Portal submitted" />
                            </div>
                        </div>
                    ) : (
                        ''
                    )}
                </div>
            ),
            fifth: asofdateHtml,
            sixth: submittedDateHtml,
            seventh: statusHtml,
        }
        return tableDataObject
    }

    useEffect(() => {
        if (sessionStorage.getItem('remote_user')) {
            getRemoteUserPermissions();
            getRemoteUserFeatures();
        }
        getTopDocuments();
    }, [])

    useEffect(() => {
        if (featureDetails?.length > 0) {
            if (!featureDetails?.includes("feature_landing_page_visible")) {
                window.location.href = "/Redirect";
            }
        }
    }, [featureDetails])


    return (
        <>
            {assignedUserName.firstName != '' ? '' : <Loader></Loader>}
            {featureDetails?.length > 0 && ["feature_landing_page_visible"].some(flag => featureDetails?.includes(flag)) ?
                <>      <GlobalHead title="U.S. Bancorp Impact Finance - USBANK" />
                    <BannerWarning></BannerWarning>
                    <USBGrid addClasses="top-frame-landing">
                        <USBColumn largeSpan={2} />
                        <USBColumn largeSpan={12}>
                            <div className='sessionHeaderLanding'>
                                <SessionHeader
                                    currentToken={currentToken}
                                    refreshTimeCount={getCurrentExtendTime()}
                                    authenticationPlugins={authenticationPlugins}
                                    extendSessionSuccess={extendSessionSuccess}
                                    onSuccessChallenge={onSuccessChallenge}
                                    onIdleTimeoutLogoutSuccess={onIdleTimeoutLogoutSuccess}
                                    onIdleTimeoutLogoutFailure={onIdleTimeoutLogoutFailure}
                                />
                            </div>
                            <div className='landing-head'>
                                <div className="landingLogo" role="img" aria-label="US Bank Logo">
                                    <img src={logo} alt="US Bank Logo"></img>
                                </div>
                                <TopMenu onLogout={onLogout} />
                                {sessionStorage.getItem('remote_user') ? <div
                                    className={'exitBtn'}
                                    onClick={() => {
                                        sessionStorage.removeItem('remote_user');
                                        sessionStorage.removeItem('sessionFilters');
                                        window.location.reload();
                                    }}
                                >
                                    Exit User
                                </div> : ''}
                            </div>
                        </USBColumn>
                        <USBColumn largeSpan={2} />
                    </USBGrid>
                    <USBGrid addClasses="content-frame">
                        <USBColumn largeSpan={16}>
                            {sessionStorage.getItem('remote_user') ? (
                                <div className="warning-panel-remote">
                                    You are impersonating the user:{' '}
                                    {JSON.parse(sessionStorage.getItem('remote_user')).firstName}{' '}
                                    {JSON.parse(sessionStorage.getItem('remote_user')).lastName}. To
                                    exit, click the 'Exit User' link above.
                                </div>
                            ) : (
                                ''
                            )}
                        </USBColumn>
                    </USBGrid>
                    <USBGrid addClasses='content-frame'>

                        <USBColumn largeSpan={2} />
                        <USBColumn largeSpan={12}>

                            {sessionStorage.getItem('remote_user') ?
                                <div className="greetingsContainer">
                                    <div>
                                        Good {new Date().getHours() < 12 ? 'Morning,' : (new Date().getHours() > 12 && new Date().getHours() < 16) ? 'Afternoon,' : 'Evening,'} <span style={{ textTransform: "capitalize" }}>{JSON.parse(sessionStorage.getItem('remote_user')).firstName}{' '}{JSON.parse(sessionStorage.getItem('remote_user')).lastName}!</span>
                                    </div>
                                    <div style={{ marginTop: '8px' }}>Welcome to the U.S. Bank Impact Finance Document Web Portal.</div>
                                </div>
                                :
                                sessionStorage.getItem('userrole') !== 'employee' ?
                                    <div className="greetingsContainer">
                                        <div>
                                            Good {new Date().getHours() < 12 ? 'Morning,' : (new Date().getHours() > 12 && new Date().getHours() < 16) ? 'Afternoon,' : 'Evening,'} <span style={{ textTransform: "capitalize" }}>{JSON.parse(sessionStorage.getItem('userData'))?.firstName}{' '}{JSON.parse(sessionStorage.getItem('userData'))?.lastName}!</span>
                                        </div>
                                        <div style={{ marginTop: '8px' }}>Welcome to the U.S. Bank Impact Finance Document Web Portal.</div>
                                    </div>
                                    :
                                    <div className='greetingsContainer'>
                                        <div>
                                            Good {new Date().getHours() < 12 ? 'Morning,' : (new Date().getHours() > 12 && new Date().getHours() < 16) ? 'Afternoon,' : 'Evening,'} {assignedUserName.firstName == "You" ? userName.firstName != 'User' ? <span style={{ textTransform: "capitalize" }}>{userName.firstName}</span> : "User" : <span style={{ textTransform: "capitalize" }}>{assignedUserName.firstName}</span>}
                                            {(assignedUserName.firstName == "You" && userName.lastName != null) ? <span style={{ textTransform: "capitalize" }}>&nbsp;{userName.lastName}</span> : (assignedUserName.lastName === '' ||
                                                assignedUserName.lastName === null) ? (
                                                ''
                                            ) : (
                                                <span>&nbsp;</span>
                                            )}
                                            <span style={{ textTransform: "capitalize" }}>{assignedUserName.lastName}!</span>
                                        </div>

                                        <div style={{ marginTop: '8px' }}>Welcome to the U.S. Bank Impact Finance Document Web Portal.</div>
                                    </div>}

                            <div className='linksHeading'>Quick Links</div>
                            <div className='tilesContainer'>
                                {tiles.map((tile, index) => {
                                    if (tile.visibility) {
                                        return <div key={index + tile.title} className={index == 3 && sessionStorage.getItem('remote_user') ? 'tile disableTile' : 'tile'} onClick={(e) => {
                                            if (index == 1) {
                                                removeImpersonatedForCB()
                                            } else if (index == 3 && sessionStorage.getItem('remote_user')) {
                                                alert("Manage Users is not accessible for impersonated user. Please exit the impersonated view to access the same.")
                                            } else {
                                                window.location.href = tile.url
                                            }
                                        }}>
                                            <div className='tileIcon'>{tile.icon}</div>
                                            <div className='tileTitle'>{tile.title}</div>
                                        </div>
                                    } else {
                                        return ''
                                    }
                                })}
                            </div>
                            {(sessionStorage.getItem('remote_user') || sessionStorage.getItem('userrole') !== 'employee') && <>
                                <div className='linksHeading'>Top Documents</div>
                                <div className='top-documents-section'>
                                    {loading ? <Loader /> :
                                        <>
                                            {topDocuments?.length > 0 ? (
                                                <>
                                                    <div className='table-controls'>
                                                        <div className='page-size-selector'>
                                                            <label>Documents per page:</label>
                                                            <select value={pageSize} onChange={(e) => handlePageSizeChange(Number(e.target.value))}>
                                                                <option value={10}>10</option>
                                                                <option value={25}>25</option>
                                                                <option value={50}>50</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <table className='top-documents-table'>
                                                        <thead>
                                                            <tr>
                                                                <th onClick={() => handleSort('dueDate')} className='sortable-header'>
                                                                    Due Date {sortColumn === 'dueDate' && <span>{sortDirection === 'asc' ? '↑' : '↓'}</span>}
                                                                </th>
                                                                <th onClick={() => handleSort('dealName')} className='sortable-header'>
                                                                    Deal Name {sortColumn === 'dealName' && <span>{sortDirection === 'asc' ? '↑' : '↓'}</span>}
                                                                </th>
                                                                <th onClick={() => handleSort('reportingEntity')} className='sortable-header'>
                                                                    Reporting Entity {sortColumn === 'reportingEntity' && <span>{sortDirection === 'asc' ? '↑' : '↓'}</span>}
                                                                </th>
                                                                <th onClick={() => handleSort('category')} className='sortable-header'>
                                                                    Document Category {sortColumn === 'category' && <span>{sortDirection === 'asc' ? '↑' : '↓'}</span>}
                                                                </th>
                                                                <th onClick={() => handleSort('asOfDate')} className='sortable-header'>
                                                                    As Of Date {sortColumn === 'asOfDate' && <span>{sortDirection === 'asc' ? '↑' : '↓'}</span>}
                                                                </th>
                                                                <th onClick={() => handleSort('submittedDate')} className='sortable-header'>
                                                                    Submitted Date {sortColumn === 'submittedDate' && <span>{sortDirection === 'asc' ? '↑' : '↓'}</span>}
                                                                </th>
                                                                <th onClick={() => handleSort('status')} className='sortable-header'>
                                                                    Status {sortColumn === 'status' && <span>{sortDirection === 'asc' ? '↑' : '↓'}</span>}
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {getPaginatedDocuments().map((doc, index) => {
                                                                const rowData = tblContentTemplate(doc, 'Not Submitted', () => { }, userCheck, () => { }, () => { }, 1, true, 'Status');
                                                                return (
                                                                    <tr
                                                                        key={doc.id || index}
                                                                        className="top-documents-row-clickable"
                                                                        title="Click to view more details"
                                                                        onClick={() => { window.location.href = rowData.rowHref; }}
                                                                    >
                                                                        <td>{rowData.first}</td>
                                                                        <td>{rowData.second}</td>
                                                                        <td>{rowData.third}</td>
                                                                        <td>{rowData.fourth}</td>
                                                                        <td>{rowData.fifth}</td>
                                                                        <td>{rowData.sixth}</td>
                                                                        <td>{rowData.seventh}</td>
                                                                    </tr>
                                                                );
                                                            })}
                                                        </tbody>
                                                    </table>
                                                    <div className='pagination-controls'>
                                                        <button
                                                            onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                                                            disabled={currentPage === 1}
                                                            className='pagination-btn'
                                                        >
                                                            Previous
                                                        </button>
                                                        <span className='pagination-info'>
                                                            Page {currentPage} of {getTotalPages()}
                                                        </span>
                                                        <button
                                                            onClick={() => setCurrentPage(prev => Math.min(prev + 1, getTotalPages()))}
                                                            disabled={currentPage === getTotalPages()}
                                                            className='pagination-btn'
                                                        >
                                                            Next
                                                        </button>
                                                    </div>
                                                </>
                                            ) : (
                                                <div className='no-documents'>No documents with upcoming due dates within 3 months.</div>
                                            )}
                                        </>
                                    }

                                </div>
                            </>}
                        </USBColumn>
                        <USBColumn largeSpan={2} />
                    </USBGrid>
                    <GlobalFooter />
                </>
                : ''}
        </>
    )
}

export default LandingPage;